/* eslint-disable @typescript-eslint/dot-notation */
/* eslint-disable no-else-return */
/* eslint-disable @typescript-eslint/prefer-optional-chain */
// import { version1Data } from './testDataVersion1';

import { isVersion2, mergeData, safeGet } from "@/pages/aigc/utils/utils";
import { DIMENSION_TAB_NAME_MAP, DIMENSION_WHITELIST, METRIC_DISPLAY_NAME, SHOW_EXCEL_DOWNLOAD_DATA_LENGTH, SHOW_EXCEL_DOWNLOAD_LEGEND_COUNT } from "../../../config/constant";
import { extractMetricDataKey } from '../AIContent/_utils';
// import { ConsoleSqlOutlined } from "@ant-design/icons";
import { hasDevice } from "@/pages/aigc/utils/dataTransform";
import { TMetricObj } from "../TabComponent/_type";
import { get, isArray, isEmpty, head, isString } from 'lodash-es';


// 工具函数：过滤掉空值字段
function pickDefinedFields(obj: Record<string, any>) {
  const res = {};
  for (const key in obj) {
    if (obj[key] !== undefined && obj[key] !== null && obj[key] !== '') {
      res[key] = obj[key];
    }
  }
  return res;
}

// 工具函数：验证最终输出格式是否合法
function validateOutput(data: any): boolean {
  return Boolean(
    data.version &&
    Array.isArray(data.dimension_info) &&
    Array.isArray(data.metrics_info) &&
    Array.isArray(data.data)
  );
}
/**
 * 获取过滤信息中的唯一数据键集合
 */
const getUniqueFilterKeys = (filterInfo: any[]): string[] => {
  const nonCascadeDataKeys = filterInfo
    .filter(item => item.filter_type !== 'cascade')
    .map(item => item.data_key);

  const cascadeDisplayInfos = filterInfo
    .filter(item => item.filter_type === 'cascade')
    .flatMap(item => item.display_info || []);

  return [...new Set([...nonCascadeDataKeys, ...cascadeDisplayInfos])];
};

/**
 * 处理筛选器的visible_value字段
 * 对于normal类型的筛选器，过滤出有效的visible_value，并同时修改对应的dimension_info
 */
const processFilterVisibleValue = (filterInfo: any[], dimensionInfo: any[]): { processedDimensionInfo: any[]; } => {
  // 输入验证
  if (!Array.isArray(filterInfo) || !Array.isArray(dimensionInfo)) {
    return { 
      processedDimensionInfo: dimensionInfo || [] 
    };
  }

  // 创建 dimensionInfo 的副本，避免直接修改原数组
  const processedDimensionInfo = dimensionInfo.map(dim => {
    // 添加对象和属性的校验
    if (!dim || typeof dim !== 'object' || !dim?.data_key) {
      return dim;
    }
    const { value = [] } = dim as { value: any[]; };
    const findFilter = filterInfo.find(f => f.data_key === dim.data_key && f.filter_type === 'normal' && Array.isArray(f.visible_value) && f.visible_value.length > 0);
    if (!findFilter) return dim;
    const { visible_value = [] } = findFilter;
    const newValue = value.filter(val => visible_value?.includes(val?.value || val));

    return {
      ...dim,
      value: newValue
    };
  });

  return { processedDimensionInfo };
};

/**
 * 辅助函数：判断两个字符串数组是否内容相同（顺序不影响）
 */
const arraysAreEqual = (a: string[], b: string[]): boolean => {
  if (a.length !== b.length) return false;
  return a.every(item => b.includes(item)) && b.every(item => a.includes(item));
};

function convertMetricsToNumber(data: any[], metricInfo: TMetricObj[]) {
  return data.map((item) => {
    // 创建新对象（避免修改原对象）
    const newItem: Record<string, any> = { ...item };

    metricInfo.forEach((metric) => {
      const key = extractMetricDataKey(metric?.data_key);
      if (metric.type === 'float' && Object.prototype.hasOwnProperty.call(newItem, key)) {
        const value = newItem[key];
        // 处理空字符串或无效值的情况
        if (value === '' || value === null || value === undefined) {
          newItem[key] = '';
        } else {
          // 安全转换为浮点数
          newItem[key] = parseFloat(value) || 0;
        }
      }
    });

    return newItem;
  });
}

/**
 * 格式化图表数据，确保维度字段完整
 */
export const formatChartTaleDta = (data: any) => {
  const { legends, filter_info, dimension_info, metrics_info, xAxis, additional_table_field, filter_default_value, ...restData } = data;
  
  // 处理筛选器的visible_value字段
  const { processedDimensionInfo } = processFilterVisibleValue(filter_info, dimension_info);

  // dimension的key数组
  const dimensionKeyList = processedDimensionInfo.map((item: any) => item?.data_key) || [];
  const xAxisVal = xAxis?.map(item => {
    if (typeof item === 'string') {
      return item;
    } else {
      return item?.date_key;
    }
  });
  // legend的key数组
  const legendsXAxisKeyList = [...(legends || []), ...(xAxisVal || [])];
  // 级联的key数组
  const filterCascadeKeyList = getUniqueFilterKeys(filter_info);
  const combinedKeys = [...new Set([...legendsXAxisKeyList, ...filterCascadeKeyList])];
  const resultData = convertMetricsToNumber(data?.data, metrics_info);
  if (arraysAreEqual(combinedKeys, dimensionKeyList)) {
    return {...data, data: resultData, additional_table_field, filter_info, dimension_info: processedDimensionInfo, filter_default_value};
  } else {
    const diff = dimensionKeyList.filter(key => !combinedKeys.includes(key));
    // const newLegends1= [...new Set([...(legends || []), ...(diff || [])])];
    // 大小写不区分，算作一个维度
    const newLegends = [...new Map([...legends, ...diff].map(key => [key.toLowerCase(), key]))?.values()];
    // 对传入的数据进行兜底处理，后端应该传[],但是传递了null
    return {
      filter_info,
      dimension_info: processedDimensionInfo?.map(item => {
        return {
          ...item,
          value: item?.value ? item?.value : []
        };
      }),
      xAxis,
      ...restData,
      legends: newLegends,
      metrics_info: metrics_info?.map((item: any) => {
        const dataKey = extractMetricDataKey(item?.data_key);
        return {
          ...item,
          name: item?.name || METRIC_DISPLAY_NAME?.[dataKey] || dataKey || '',
        };
      }),
      additional_table_field,
      filter_default_value,
      data: resultData,
    };
  }
};

/**
 * 格式化后端的接口协议
 */
export const formatData = (inputData: any) => {
  if (isVersion2(inputData?.[0]?.data)) {
    return inputData?.[0]?.data;
  } else {
    if (inputData?.[0]?.data?.data) {
      const realData: any = [];
      inputData.forEach(item => {
        realData.push(...(item?.data?.data || []));
      });

      inputData[0].data.data = mergeData(inputData, realData);
      inputData = [inputData?.[0]];
    }
    const result = convertVersion1ToTest(inputData);
    if (!validateOutput(result)) {
      console.error('[convertVersion1ToTest] 数据格式错误，转换失败');
      throw new Error('Invalid output format');
    }
    return result;
  }
};

/**
 * 将 version1Data 转换为 testData 的结构
 */
function convertVersion1ToTest(version1Data) {

  let metricsValue = version1Data?.[0]?.data?.data?.[0]?.metric_value;
  // console.log('metricsValuemetricsValue',metricsValue)
  const hasDeviceKey = hasDevice(metricsValue);
  if (metricsValue && hasDeviceKey) {
    metricsValue = metricsValue?.map(item => ({ ...item, platform: item?.platform || item?.device, }));;
    version1Data[0].data.data[0].metric_value = metricsValue;
  }
  // console.log('version1Data',version1Data)

  // 提取指标信息
  const metrics = extractMetrics(version1Data);
  // 构建数据
  const data = buildData(version1Data);
  // 提取维度信息
  const dimensions = extractDimensions(version1Data);

  // 构建筛选器
  const filters = buildFilterInfo(metrics, dimensions, data);


  return {
    version: '2.0',
    xAxis: ['date'],
    yAxis: ['value'],
    legends: ['game_name'],
    title: safeGet(version1Data, [0, 'title']),
    chat_type: 'trend',
    metrics_info: metrics,
    dimension_info: dimensions,
    filter_info: filters,
    data
  };
}

/**
 * 提取指标信息
 */
function extractMetrics(version1Data) {
  return safeGet(version1Data, [0, 'data', 'metrics_info'], []).map(metric => ({
    name: '',
    data_key: metric?.data_key,
    type: metric.type,
    icon: 'icon',
    icon_active: 'icon_active'
  }));
}

/**
 * 提取并补全维度信息
 */
function extractDimensions(version1Data: any) {
  let dimensionMap: any = {};
  const dimInfos = safeGet(version1Data, [0, 'data', 'dimension_info'], []);
  dimInfos.forEach((d: { data_key: string | number; value: Iterable<unknown> | null | undefined; }) => {
    dimensionMap[d?.data_key] = {
      ...d,
      value: Array.isArray(d?.value) ? [...new Set(d?.value)] : d?.value || []
    };
  });

  // 判断是否需要补充 platform
  let hasPlatformInMetricValue = false;
  const gameDataList = safeGet(version1Data, [0, 'data', 'data'], []);
  gameDataList.forEach(game => {
    game.metric_value.forEach(metric => {
      if (metric?.platform) hasPlatformInMetricValue = true;
    });
  });
  // 只有原始数据中存在 platform 才保留该维度,其实不需要，但是后端有时候返回的key为Platform，这里算作兜底处理，不然图表无法展示
  if (hasPlatformInMetricValue) {
    dimensionMap['platform'] = {
      name: '平台',
      data_key: 'platform',
      value: []
    };
  }
  // console.log('dimensionMap1', dimensionMap)
  // 补充其他固定维度（如果存在）
  // const requiredDimensions = ['game_name', 'source', 'market_name', 'date', 'game_type', 'granularity', 'platform', 'language', 'channel_name', 'region', 'code', 'region_name'];
  DIMENSION_WHITELIST.forEach(key => {
    if (!dimensionMap[key]) {
      dimensionMap[key] = {
        name: DIMENSION_TAB_NAME_MAP?.[key] || key, // 可根据实际需求填充中文名
        data_key: key,
        value: []
      };
    }
  });

  // console.log('dimensionMap2', dimensionMap)

  // 从 data 中提取缺失的维度值
  gameDataList.forEach(game => {

    // 'game_name','source', 'market_name', 'date', 'game_type', 'granularity', 'platform', 'language', 'channel_name',  'region', 'code', 'region_name'
    // 处理指标级别的维度
    game.metric_value.forEach(metric => {
      DIMENSION_WHITELIST.forEach(key => {
        addUniqueValue(dimensionMap, key, metric[key]);
      });
    });
  });
  dimensionMap = filterEmptyDimensions(dimensionMap);
  console.log('dimensionMap', dimensionMap);
  return Object.values(dimensionMap);
}

function addUniqueValue(dimensionMap: any, key: string, value: any) {
  if (value && !dimensionMap[key]?.value.includes(value)) {
    dimensionMap[key].value.push(value);
  }
}

/**
 * 过滤掉 dimensionMap 中 value 为空的维度
 * @param dimensionMap 维度映射对象
 * @returns 过滤后的维度映射对象
 */
function filterEmptyDimensions(dimensionMap: Record<string, any>): Record<string, any> {
  const filtered: Record<string, any> = {};

  Object.entries(dimensionMap).forEach(([key, dimension]) => {
    // 检查 value 是否存在且有有效内容（数组长度 > 0）
    if (dimension?.value?.length > 0) {
      filtered[key] = dimension;
    }
  });

  return filtered;
}

/**
 * 构建筛选器配置
 */
function buildFilterInfo(metrics, dimensions, data) {
  const filters = [];
  // const metricKeys = metrics.map(m => m.data_key);

  // granularity - 普通筛选器
  const granularityDim = dimensions.find(d => d.data_key === 'granularity');
  if (granularityDim?.value?.length > 0) {
    filters.push({
      name: '',
      data_key: 'granularity',
      filter_type: 'normal'
    });
  }
  const cascadeData = generateCascade(data, metrics);
  filters.push(cascadeData);
  return filters;
}

function generateCascade(data, metrics) {
  // 1. 构建精确的三级关系映射
  const relationMap = new Map<string, Map<string, Set<string>>>();

  // 预先收集所有metric keys
  const allMetricKeys = new Set(metrics.map(m => m.data_key));

  // 遍历数据建立精确关联
  data.forEach((item: { [x: string]: null; game_type?: any; source?: any; }) => {
    const { game_type, source } = item;

    // 初始化game_type层级
    if (!relationMap.has(game_type)) {
      relationMap.set(game_type, new Map());
    }
    const sourceMap = relationMap.get(game_type)!;

    // 初始化source层级
    if (!sourceMap.has(source)) {
      sourceMap.set(source, new Set());
    }
    const metricSet = sourceMap.get(source)!;

    // 检查item中实际存在的metrics
    Object.keys(item).forEach(key => {
      // 必须是预定义的metric且有值
      if (allMetricKeys.has(key) && item[key] != null) {
        metricSet.add(key);
      }
    });
  });

  // 2. 构建最终数据结构
  const gameTypes = Array.from(relationMap.keys());
  const displayValue: Record<string, Record<string, string[]>> = {};

  relationMap.forEach((sourceMap, gameType) => {
    displayValue[gameType] = {};

    sourceMap.forEach((metricSet, source) => {
      // 只包含实际存在的metrics
      displayValue[gameType][source] = Array.from(metricSet);

      // 验证metrics是否确实存在于data中
      const relatedItems = data.filter(
        item => item.game_type === gameType && item.source === source
      );

      // 再次过滤确保准确性
      displayValue[gameType][source] = displayValue[gameType][source].filter(
        metric => relatedItems.some(item => item[metric] != null)
      );
    });
  });

  return {
    name: "",
    data_key: "game_type",
    filter_type: "cascade",
    has_metric: true,
    value: gameTypes,
    display_info: ["game_type", "source"],
    display_value: displayValue
  };
}
/**
 * 构建 data 字段，仅提取原始数据中存在的维度字段
 */
function buildData(version1Data: any) {
  let result: any = [];
  const gameDataList = safeGet(version1Data, [0, 'data', 'data'], []);

  // const DIMENSION_WHITELIST = ['game_name', 'game_type', 'source', 'date', 'market_name', 'granularity', 'platform', , 'language', 'channel_name', 'region', 'code', 'region_name'];

  gameDataList.forEach(game => {
    game.metric_value.forEach(metric => {
      const base: Record<string, any> = {};
      DIMENSION_WHITELIST.forEach(key => {
        if (game[key] !== undefined) {
          base[key] = game[key];
        } else if (metric[key] !== undefined) {
          base[key] = metric[key];
        }
      });

      const metrics: any = {};
      safeGet(version1Data, [0, 'data', 'metrics_info'], []).forEach(m => {
        if (metric[m.data_key] !== undefined) {
          metrics[m.data_key] = metric[m.data_key];
        }
      });
      result.push(pickDefinedFields({
        ...base,
        ...metrics
      }));
    });
  });
  // v1版本的协议，保留之前逻辑，不支持date，没有date则不展示
  result = result?.filter((item: { date: any; }) => item?.date);
  return result;
}

/**
 * 计算图例数量
 * @param legends 图例数组，包含 dimension_info 中的 data_key
 * @param dimensionInfo 维度信息数组
 * @returns 图例数量（单个 legend 返回对应 value 数组长度，多个 legend 返回各 value 数组长度的乘积）
 */
export const calculateLegendCount = (legends: any[], dimensionInfo: any[] = []): number => {
  if (!Array.isArray(legends) || legends.length === 0) {
    return 0;
  }
  
  if (!Array.isArray(dimensionInfo) || dimensionInfo.length === 0) {
    return 0;
  }
  
  // 提取 legends 中的 data_key（可能是字符串或对象）
  const legendKeys = legends.map(legend => {
    if (typeof legend === 'string') {
      return legend;
    }
    if (legend && typeof legend === 'object' && legend?.date_key) {
      return legend.date_key;
    }
    return legend;
  });
  
  // 如果只有一个 legend，返回对应 dimension_info 的 value 数组长度
  if (legendKeys.length === 1) {
    const dimension = dimensionInfo.find(dim => dim?.data_key === legendKeys[0]);
    if (dimension && Array.isArray(dimension?.value)) {
      return dimension?.value?.length;
    }
    return 0;
  }
  
  // 如果有多个 legend，计算各 value 数组长度的乘积
  const valueLengths = legendKeys.map(key => {
    const dimension = dimensionInfo.find(dim => dim?.data_key === key);
    if (dimension && Array.isArray(dimension?.value)) {
      return dimension?.value?.length;
    }
    return 0;
  });
  
  // 计算乘积
  return valueLengths.reduce((product, length) => product * length, 1);
};

/**
 * 检查 xAxis 对应维度的 value 数组长度是否超过阈值（纯函数）
 * @param xAxisArray - xAxis 数组
 * @param dimensionInfo - 维度信息数组
 * @param threshold - 阈值，默认为 SHOW_EXCEL_DOWNLOAD_DATA_LENGTH
 * @returns 是否超过阈值
 */
export const checkXAxisDimensionValueLength = (
  xAxisArray: any[] | undefined,
  dimensionInfo: any[] = [],
  threshold: number = SHOW_EXCEL_DOWNLOAD_DATA_LENGTH
): boolean => {
  // 使用 lodash 进行安全检查
  if (!isArray(xAxisArray) || isEmpty(xAxisArray)) {
    return false;
  }
  
  if (!isArray(dimensionInfo) || isEmpty(dimensionInfo)) {
    return false;
  }
  
  // 获取 xAxis 的第一个元素
  const firstXAxisItem = head(xAxisArray);
  
  // 提取 xAxisKey
  const xAxisKey = isString(firstXAxisItem) 
    ? firstXAxisItem 
    : get(firstXAxisItem, 'date_key');
  
  // 如果没有有效的 xAxisKey，返回 false
  if (!xAxisKey) {
    return false;
  }
  
  // 在 dimension_info 中查找对应的维度信息
  const matchedDimension = dimensionInfo.find(
    (dim: any) => get(dim, 'data_key') === xAxisKey
  );
  
  // 检查该维度的 value 数组长度
  const dimensionValue = get(matchedDimension, 'value');
  
  if (!isArray(dimensionValue)) {
    return false;
  }
  
  return dimensionValue.length > threshold;
};

/**
 * 判断结果类型
 */
export interface IRenderDecision {
  shouldShowDownload: boolean;
  reason: 'format_file' | 'data_too_large' | 'legends_too_many' | 'normal' | 'xAxis is date or time' | 'xAxis_dimension_value_too_large';
}

/**
 * 从 apiData 中提取 format 字段
 * @param apiData - API 返回的数据
 * @returns format 值
 */
export const getFormatFromApiData = (apiData: any[]): string | undefined => {
  if (!Array.isArray(apiData) || apiData.length === 0) {
    return undefined;
  }
  return apiData[0]?.format;
};

/**
 * 判断是否应该渲染为下载模式
 * @param apiData - API 返回的数据
 * @param formattedData - 格式化后的数据（可选，用于性能优化）
 * @returns 判断结果
 */
export const shouldRenderAsDownload = (
  apiData: any[],
  formattedData?: any
): IRenderDecision => {

  const format = getFormatFromApiData(apiData);
  const data = formattedData || safeGet(apiData, [0, 'data']);
  const chatType = get(data, 'chat_type', []);

  // 1. 如果 from 等于 'ds-agent' 或 chat_type 有且只有一个 'table'，不需要展示下载链接
  const isDsAgent = apiData?.[0]?.from === 'ds-agent';
  const isOnlyTable = isArray(chatType) && chatType?.length === 1 && chatType?.[0] === 'table';
  if (isDsAgent || isOnlyTable) {
    return {
      shouldShowDownload: false,
      reason: 'normal',
    };
  }

  // 2. 检查 format 字段，后端返回格式为 file 直接走下载
  if (format === 'file') {
    return {
      shouldShowDownload: true,
      reason: 'format_file',
    };
  }
  const xAxis = data?.xAxis || formattedData?.xAxis;
  const dimensionInfo = get(data, 'dimension_info', []);

  // 2. 图例数量超过阈值，走下载（优先级高于 xAxis 判断）
  if (format === 'none' || !format || format === 'graph') {
    if (data) {
      const legends = data?.legends || [];
      const legendCount = calculateLegendCount(legends, dimensionInfo);
      if (legendCount > SHOW_EXCEL_DOWNLOAD_LEGEND_COUNT) {
        return {
          shouldShowDownload: true,
          reason: 'legends_too_many',
        };
      }
    }
  }

  // 3. X 轴是日期或时间，直接展示图表，不管数据量多大
  if (xAxis && Array.isArray(xAxis) && xAxis.length > 0) {
    const xAxisDateKey = typeof xAxis[0] === 'object' && xAxis[0]?.date_key
      ? xAxis[0].date_key
      : typeof xAxis[0] === 'string'
        ? xAxis[0]
        : null;

    if (xAxisDateKey && (xAxisDateKey === 'date' || xAxisDateKey === 'time')) {
      return {
        shouldShowDownload: false,
        reason: 'xAxis is date or time',
      };
    }
  }

  // 4. X 轴维度值超过阈值，走下载
  if (format === 'none' || !format || format === 'graph') {
    if (!data) {
      return {
        shouldShowDownload: false,
        reason: 'normal',
      };
    }

    const xAxisArray = get(data, 'xAxis');
    if (checkXAxisDimensionValueLength(xAxisArray, dimensionInfo)) {
      return {
        shouldShowDownload: true,
        reason: 'xAxis_dimension_value_too_large',
      };
    }
  }
  
  // 默认显示图表
  return {
    shouldShowDownload: false,
    reason: 'normal',
  };
};